export const normalizeImageUrl = (u) => {
  if (!u || typeof u !== 'string') return '';
  // Handle cases where the URL might be wrapped in brackets, backticks, quotes, or spaces
  // This handles stringified arrays like '["image.jpg"]' or quoted URLs
  let s = u.replace(/[\[\]`'"]/g, '').trim();
  
  if (/^(?:https?:|data:|blob:)/i.test(s)) {
    // Recursively handle double-prefixed URLs: https://api.chilltree.scienstechnologies.com/uploads/https://api.chilltree.scienstechnologies.com/uploads/filename.jpeg
    while (/^https?:\/\/[^/]+\/uploads\/https?:\/\//i.test(s)) {
      s = s.replace(/^https?:\/\/[^/]+\/uploads\//i, '');
    }

    // Handle duplicated /uploads/ path segments
    s = s.replace(/\/uploads\/uploads\/+/i, '/uploads/');
    return s;
  }
  
  s = s.replace(/^\/+/, '');
  s = s.replace(/^uploads\/+/i, '');
  if (s.startsWith('http')) return s;
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const uploadsBaseUrl = baseUrl.replace('/api/v1', '');
  return `${uploadsBaseUrl}/uploads/${s}`;
};

export const getProductImages = (p) => {
  if (!p) return [];
  let images = [];
  
  if (Array.isArray(p.image_url)) {
    images = p.image_url.filter((u) => typeof u === 'string' && u);
  } else if (typeof p.image_url === 'string' && p.image_url) {
    images = [p.image_url];
  } else if (Array.isArray(p.images)) {
    images = p.images
      .map((img) => {
        if (typeof img === 'string') return img;
        return img?.image_url || img?.file_url || img?.url || img?.path || '';
      })
      .filter(Boolean);
  } else if (Array.isArray(p.image)) {
    images = p.image.map((u) => (typeof u === 'string' ? u : '')).filter(Boolean);
  } else if (typeof p.image === 'string' && p.image) {
    images = [p.image];
  }
  
  return images.map((u) => normalizeImageUrl(u));
};
